import React from 'react';
import _ from 'lodash';
import { Form } from 'semantic-ui-react';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../../HelperMethods/FormUtils';
import { getTimeToNextPriorityOptions } from '../../../../HelperMethods/TaskUtilities';
// import { parseJSONStringToObject } from '../../../../HelperMethods/UtilityFunctions';

const TimeToNextPriority = (props) => {
  const { attributeObj, disabled, formik } = props;

  const timeToNextPriorityVal = _.get(formik.values, attributeObj.attributeName);
  const attributeOnChange = (event, data) => {
    formik.setFieldValue(attributeObj.attributeName, data.value);
  };

  return (
    <Form.Field>
      <>
        <label>
          Time To Next Priority(days)
          {attributeObj.isMandatory ? <span className="mandatory-field">*</span> : null}
        </label>
        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.PICKLIST]({
          name: attributeObj.attributeName,
          value: timeToNextPriorityVal,
          options: getTimeToNextPriorityOptions(),
          placeholder: attributeObj.displayName || attributeObj.name,
          onChange: attributeOnChange,
          multiple: attributeObj.multiple,
          disabled,
        })}
      </>
    </Form.Field>
  );
};

export default TimeToNextPriority;
